import store from '../store'
// import {Auth} from 'aws-amplify'
import {API} from "aws-amplify"
import { Auth } from 'aws-amplify'


// const instance = axios.create({
//     baseURL: 'https://vbxxv2ecg8.execute-api.eu-west-1.amazonaws.com/dev',
//     json:true
// });


// const BASE_URL = "https://vbxxv2ecg8.execute-api.eu-west-1.amazonaws.com/dev"
// const TABLE_NAME = "cmdb_dev"
const RESOURCE_NAME = "/configs"
const ENDPOINT_NAME = "cmdb"
const OPTIONS_RESOURCE_NAME = "/options"


export default {
    getAllConfigs() {

        this.checkUserLoggedIn()

        let jwtToken = store.getters['authstore/userIdJwtToken']

        let myInit = { // OPTIONAL
            headers:{
                'Authorization': 'Bearer '+jwtToken,
            },
        }

        return API.get(ENDPOINT_NAME, RESOURCE_NAME, myInit)

    },
    getConfig(guid) {

        this.checkUserLoggedIn()
        
        // store.replaceState({})
        let jwtToken = store.getters['authstore/userIdJwtToken']

        console.log("token is ..." +jwtToken)
        let myInit = { // OPTIONAL
            headers:{
                'Authorization': 'Bearer '+jwtToken
            },
        }
        return API.get(ENDPOINT_NAME, RESOURCE_NAME+"/"+guid, myInit)
    },
    getConfigHistory(guid) {

        this.checkUserLoggedIn()

        let jwtToken = store.getters['authstore/userIdJwtToken']

        let myInit = { // OPTIONAL
            headers:{
                'Authorization': 'Bearer '+jwtToken
            },
        }
        return API.get(ENDPOINT_NAME, RESOURCE_NAME+"/"+guid+"/history", myInit)
    },
    updateConfig(guid, linetagOnLoad, data) {

        this.checkUserLoggedIn()

        let jwtToken = store.getters['authstore/userIdJwtToken']

        let myInit = { 
            body: data,
            headers:{
                'Authorization': 'Bearer '+jwtToken
            },
            response: true, // (return the entire Axios response object instead of only response.data)
        }
        return API.put(ENDPOINT_NAME, RESOURCE_NAME+"/"+guid+"/"+linetagOnLoad, myInit)
    },
    createConfig(data) {

        this.checkUserLoggedIn()

        let jwtToken = store.getters['authstore/userIdJwtToken']
           
        let myInit = { //
            body: data,
            headers:{
                'Authorization': 'Bearer '+jwtToken,
                'Content-Type' : 'application/json'
            },
            response: true, // (return the entire Axios response object instead of only response.data)
        }
        return API.post(ENDPOINT_NAME, RESOURCE_NAME, myInit)
    },
    deleteConfig(guid, linetag) {

        this.checkUserLoggedIn()

        let jwtToken = store.getters['authstore/userIdJwtToken']

        let myInit = { // OPTIONAL
            headers:{
                'Authorization': 'Bearer '+jwtToken
            },
            response: true,
        }
        return API.del(ENDPOINT_NAME, RESOURCE_NAME+"/"+guid+"/"+linetag, myInit)

    },
    getAllowedOptions(field, searchTerm) {

        this.checkUserLoggedIn()

        searchTerm = encodeURI(searchTerm)
        field = encodeURI(field)

        let jwtToken = store.getters['authstore/userIdJwtToken']
        let myInit = { // OPTIONAL
            headers:{
                'Authorization': 'Bearer '+jwtToken,
            },
        }

        return API.get(ENDPOINT_NAME, OPTIONS_RESOURCE_NAME+"/"+field+"?like="+searchTerm, myInit)
    },
    checkUserLoggedIn(){
        Auth.currentAuthenticatedUser({ bypassCache: true })
        .then(data => {
            if (data && data.signInUserSession) {
                return
            } else {
                window.location.href = '/auth'
            }
        })
        .catch((e) => {
            window.location.href = '/auth'
        })
    },
    // refreshAuthenticatedUser() {    //will keep refreshing the token before any api call, currently not used instead am trying the axios interceptor to rather just redirect to /auth if user not authed.
    //                                 //may make more sens to make this an axios interceptor on request
    //     Auth.currentAuthenticatedUser()
    //     .then(user => {
    //         store.dispatch('authstore/setUser', user)
    //     })
    //     .catch(() => {
    //         store.dispatch('authstore/setUser', null)
    //     })
    // }
}
